import { IResourceComponentsProps } from '@refinedev/core';
import { AntdInferencer } from '@refinedev/inferencer/antd';

export const KycLv2Show: React.FC<IResourceComponentsProps> = () => {
  return <AntdInferencer />;
};
